/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from '@/lib/api';

export const getConsentTemplates = () => api.get('/consents/templates').then((r) => r.data);
export const registerFeaEvidence = (payload) => api.post('/consents/fea', payload).then((r) => r.data);
export const listFeaEvidence = () => api.get('/consents/fea').then((r) => r.data);
export const verifyFeaHash = (document_sha256) => api.post('/consents/fea/verify', { document_sha256 }).then((r) => r.data);
